<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <form class="calcRoi-form">
        <div class="form-group row">
          <label for="form-sizes" class="col-12 col-form-label"
            >Creative Sizes <span>(max 10)</span></label
          >
          <div class="col-12">
            <select
              class="form-control"
              :class="{ 'is-invalid': numOfSizesStatus }"
              id="form-sizes"
              v-model="roiNumOfSizes"
            >
              <option value="" disabled selected hidden
                >Select your sizes</option
              >

              <option
                v-for="quantity in numQuantity.sizes"
                :key="quantity"
                :value="quantity.toString()"
              >
                {{ quantity }}
              </option>
            </select>
            <div class="invalid-feedback">
              Please select sizes.
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="form-frames" class="col-12 col-form-label"
            >Creative Frames <span>(max 4)</span></label
          >
          <div class="col-12">
            <select
              class="form-control"
              :class="{ 'is-invalid': numOfFramesStatus }"
              id="form-frames"
              v-model="roiNumOfFrames"
              ><option value="" disabled selected hidden
                >Select your frames</option
              >
              <option
                v-for="quantity in numQuantity.frames"
                :key="quantity"
                :value="quantity.toString()"
                >{{ quantity }}</option
              ></select
            >
            <div class="invalid-feedback">
              Please select frames.
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="form-variations" class="col-12 col-form-label"
            >Creative Variations <span>(max 50)</span></label
          >
          <div class="col-12">
            <select
              class="form-control"
              :class="{ 'is-invalid': numOfVariationsStatus }"
              id="form-variations"
              v-model="roiNumOfVariations"
              ><option value="" disabled selected hidden
                >Select your variations</option
              >
              <option
                v-for="quantity in numQuantity.variations"
                :key="quantity"
                :value="quantity.toString()"
                >{{ quantity }}</option
              ></select
            >
            <div class="invalid-feedback">
              Please select variations.
            </div>
          </div>
        </div>
        <div class="form-group row justify-content-center form-btn">
          <div class="col-sm-auto">
            <button
              class="btn btn-primary"
              @click.prevent="calculateROI"
              :disabled="btnDisable"
            >
              <div
                class="spinner-border spinner-border-sm"
                :class="btnDisable ? '' : 'd-none'"
                role="status"
                aria-hidden="true"
              ></div>
              Calculate ROI
            </button>
          </div>
        </div>
        <div class="form-group">
          <SubmitMessage :status="msgStatus" :message="msg" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import SubmitMessage from '../components/SubmitMessage'

export default {
  name: 'CalculateROI',
  components: { SubmitMessage },
  props: {
    numOfSizes: { type: String, required: true },
    numOfFrames: { type: String, required: true },
    numOfVariations: { type: String, required: true }
  },
  data() {
    return {
      numQuantity: {
        sizes: 10,
        frames: 4,
        variations: 50
      },
      numOfSizesStatus: false,
      numOfFramesStatus: false,
      numOfVariationsStatus: false,
      msg: '',
      msgStatus: false,
      btnDisable: false,
      roiRecord: []
    }
  },
  mounted() {
    let roiRecord = JSON.parse(localStorage.getItem('calculateROI'))
    if (roiRecord) {
      this.roiRecord = roiRecord
    }
  },
  computed: {
    roiNumOfSizes: {
      get() {
        return this.numOfSizes
      },
      set(value) {
        this.$emit('update:numOfSizes', value)
      }
    },
    roiNumOfFrames: {
      get() {
        return this.numOfFrames
      },
      set(value) {
        this.$emit('update:numOfFrames', value)
      }
    },
    roiNumOfVariations: {
      get() {
        return this.numOfVariations
      },
      set(value) {
        this.$emit('update:numOfVariations', value)
      }
    }
  },
  methods: {
    async calculateROI() {
      this.submitStatusChangeHandler(true, 'success', '') // btnDisable, msgStatus, msg
      let formValid = this.formValidHandler()
      // console.log(formValid)

      if (!formValid) {
        this.submitStatusChangeHandler(
          false,
          'error',
          'One or more fields have an error. Please check and try it again.'
        )
        return
      }

      try {
        let response =
          process.env.NODE_ENV === 'development'
            ? await this.responseTest()
            : await this.roiResponse()
        console.log(response)
        this.submitStatusChangeHandler(false, 'success', '')
        this.recordToLocalStorage()
        this.$emit('calculateRoiResponse', response)
      } catch (err) {
        if (err.response) {
          if (err.response.status === 429) {
            console.error(err.response.data)
            this.submitStatusChangeHandler(
              true,
              'error',
              'Too many requests, please wait a minute and try it again.'
            )
            this.roiRequestCounter()
          }
        } else {
          console.error(err)
          this.submitStatusChangeHandler(
            false,
            'error',
            'Please wait a minute and try it again.'
          )
        }
      }
    },
    submitStatusChangeHandler(btnDisable, msgStatus, msg) {
      this.btnDisable = btnDisable
      this.msgStatus = msgStatus
      this.msg = msg
    },
    formValidHandler() {
      !this.numOfSizes
        ? (this.numOfSizesStatus = true)
        : (this.numOfSizesStatus = false)
      !this.numOfFrames
        ? (this.numOfFramesStatus = true)
        : (this.numOfFramesStatus = false)
      !this.numOfVariations
        ? (this.numOfVariationsStatus = true)
        : (this.numOfVariationsStatus = false)
      return (
        !this.numOfSizesStatus &&
        !this.numOfFramesStatus &&
        !this.numOfVariationsStatus
      )
    },
    roiResponse() {
      return this.$http.post(
        'https://ddc-roi.api.fivestones.net/calculate',
        {
          numOfSizes: this.numOfSizes,
          numOfFrames: this.numOfFrames,
          numOfVariations: this.numOfVariations
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    },
    responseTest() {
      return {
        data: {
          budgetSaved: {
            AUD: '49,275',
            CNY: '243,958',
            EUR: '30.539',
            GBP: '27,893',
            HKD: '288,815',
            IDR: '528.260.875',
            KRW: '41,061,606',
            NZD: '52,542',
            SGD: '49,669',
            THB: '1,118,245',
            TWD: '1,049,202',
            USD: '37,250'
          },
          defaultCurrency: 'TWD',
          hoursSaved: '184'
        }
      }
    },
    recordToLocalStorage() {
      this.roiRecord.push({
        timestamp: Math.floor(new Date().getTime() / 1000),
        numOfSizes: this.numOfSizes,
        numOfFrames: this.numOfFrames,
        numOfVariations: this.numOfVariations
      })
      localStorage.setItem('calculateROI', JSON.stringify(this.roiRecord))
    },
    roiRequestCounter() {
      setTimeout(() => {
        this.submitStatusChangeHandler(
          false,
          'success',
          'you can claculate again.'
        )
      }, 60000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CalculateROI.vue